import { atom } from "recoil";

export default atom({
  key: "page-header",
  default: {
    title: "",
    back: false,
  },
});
